import { useCallback, useEffect } from 'react';

import { useNextRender } from '../useNextRender/useNextRender';

/**
 * auto scroll the page to the div section
 */
export const usePageScroll = () => {
  const [nextRender] = useNextRender();

  const scrollToSection = useCallback( ( targetId ) => {
    const targetSection = document.getElementById( targetId );
    if( targetSection ){
      targetSection.scrollIntoView();
    }
  }, [] );

  useEffect( () => {
    const targetId = ( window.location.href ).split( '#' )[1];
    if( targetId ){
      nextRender( () => scrollToSection( targetId ) );
    }
  }, [nextRender, scrollToSection] );
};